// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vant from 'vant';
import { Lazyload } from 'vant';

import BaiduMap from 'vue-baidu-map'
import 'vant/lib/index.css';
// import 'vant/lib/index.less';
import '@/permission' // permission control
import { global } from './commonJs/common'
import Meta from 'vue-meta';
Vue.config.productionTip = false
Vue.use(Meta);
Vue.use(Vant);
Vue.use(Lazyload);
Vue.config.ignoredElements = ['wx-open-launch-weapp']
/* eslint-disable no-new */

Vue.use(BaiduMap, {
  // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
  // ak: 'NFsHGXiKfqIlBptlFOoDphO3'
  // ak: 'Mwu7uQKUj0YtapQ4gKftGsikboeLjYPG'
  ak:'OxfxNUhj5ITh5IeZdCGFiZZybX4BN3vI'
})

new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
})

Vue.prototype.global = global;


// WEBPACK FOOTER //
// ./src/main.js